import {
  Button,
  Divider,
  Drawer,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  NotificationInfo,
  SubscriptionInfo,
  UserInfo,
} from "../../../../context";
import { useReactToPrint } from "react-to-print";
import {
  PrinterOutlined,
  CloseSquareOutlined,
  PlusSquareOutlined,
} from "@ant-design/icons";
import moment from "moment";
import _ from "lodash";
import TextArea from "antd/es/input/TextArea";

const MerchantARReportOrderDetails = ({
  open,
  close,
  selectedData,
  rerunVoid,
  rerunWaste,
  getMerchantOrderSaveList,
}) => {
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const [totalCost, setTotalCost] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalPerProd, setTotalPerProd] = useState(0);
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openAddWaste, setOpenAddWaste] = useState(false);
  const [openVoidTransaction, setOpenVoidTransaction] = useState(false);
  const [tableData, setTableData] = useState(null);
  const { rerunNotif } = useContext(NotificationInfo);
  const [employeeList, setEmployeeList] = useState({
    data: [],
    ready: false,
  });
  const [newOrderDetailsList, setNewOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const [openConfirmDiag, setOpenConfirmDiag] = useState(false);
  const [form] = Form.useForm();
  const [inputtedPayment, setInputtedPayment] = useState(null);
  const [inputtedEcashPayment, setInputtedEcashPayment] = useState(null);
  const [selectedMethod, setSelectedMethod] = useState("");
  const { subscriptionDetails } = useContext(SubscriptionInfo);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      // dataIndex: "product",
      render: (text, record) => (
        <p>
          {text.product}
          {parseInt(text.is_per_piece) === 0 && ` - ${text.quantity}gram(s)`}
        </p>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    userData.data.perproductcost !== null && {
      title: userData.data.perproductcost.description,
      align: "right",
      // dataIndex: "cost_per_prod",
      render: (text) => (
        <p>
          &#8369;
          {parseFloat(
            parseInt(text.is_per_piece) === 0
              ? text.cost_per_prod
              : text.cost_per_prod * text.quantity
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "Price x Qty",
      align: "right",
      render: (text, record) => (
        <>
          {parseInt(text.is_per_piece) === 1 ? (
            <p style={{ minWidth: 80, textAlign: "right" }}>
              &#8369;{text.price} x {text.quantity}
            </p>
          ) : (
            <p style={{ minWidth: 80, textAlign: "right" }}>
              &#8369;{text.price}
            </p>
          )}
        </>
        // <>
        //   &#8369;{text.price} x {text.quantity}
        // </>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 90,
      render: (text) => (
        <p
          style={{
            width: window.innerWidth > 883 ? "auto" : 80,
          }}
        >
          {text.order_category !== "additional-service" && (
            <Tooltip title="Add Waste">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setTableData(text);
                  setOpenAddWaste(true);
                }}
                icon={<PlusSquareOutlined />}
                style={{ marginRight: 5 }}
                size="small"
              />
            </Tooltip>
          )}

          <Tooltip title="Void">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setTableData(text);
                setOpenVoidTransaction(true);
              }}
              icon={<CloseSquareOutlined />}
              size="small"
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const columns2 = [
    {
      title: "Product",
      dataIndex: "product",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    userData.data.perproductcost !== null && {
      title: userData.data.perproductcost.description,
      align: "right",
      // dataIndex: "cost_per_prod",
      render: (text) => (
        <p>
          &#8369;
          {parseFloat(
            parseInt(text.is_per_piece) === 0
              ? text.cost_per_prod
              : text.cost_per_prod * text.quantity
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "Price",
      align: "right",
      render: (text, record) => <>&#8369;{text.price}</>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 90,
      render: (text) => (
        <p
          style={{
            width: window.innerWidth > 883 ? "auto" : 80,
          }}
        >
          {text.order_category !== "additional-service" && (
            <Tooltip title="Add Waste">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setTableData(text);
                  setOpenAddWaste(true);
                }}
                icon={<PlusSquareOutlined />}
                style={{ marginRight: 5 }}
                size="small"
              />
            </Tooltip>
          )}

          <Tooltip title="Void">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setTableData(text);
                setOpenVoidTransaction(true);
              }}
              icon={<CloseSquareOutlined />}
              size="small"
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const tableColumns2 = columns2.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantOrderDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      transaction_id: selectedData !== null ? selectedData.transaction_id : "",
      order_category: "all",
    };
    axios
      .get("user/merchant/spec-transaction-info", {
        params,
      })
      .then((response) => {
        const data = response.data;

        const res = _.chain(data)
          .groupBy((g) => g.order_category)
          .map((value, key) => ({
            order_category: key,
            data: value,
            total: consumptionTotal(value),
            discount: calculateDiscount(value),
            perproduct: calculatePerProdCost(value),
          }))
          .value();
        // console.log("RES: ", res);
        setNewOrderDetailsList({ data: res, ready: true });

        setOrderDetailsList({ data, ready: true });
        setTotalCost(calculateTotal(data));
        setTotalDiscount(calculateDiscount(data));
        setTotalPerProd(calculatePerProdCost(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  const getEmployeeList = useCallback(() => {
    var params = { user_id: userData.data.id, status: 1 };
    axios
      .get("user/merchant/employee-list", { params })
      .then((response) => {
        const data = response.data;
        setEmployeeList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      // total += parseFloat(data[i].quantity) * parseFloat(data[i].price);

      total +=
        parseInt(data[i].is_per_piece) === 1
          ? parseFloat(data[i].quantity) *
            parseFloat(data[i].price.replace(",", ""))
          : parseFloat(data[i].price.replace(",", ""));
    }
    return total;
  };

  const consumptionTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        data[i].service_type === "consumable"
          ? parseFloat(data[i].price.replace(",", "")) * 1
          : parseFloat(data[i].quantity) *
            parseFloat(data[i].price.replace(",", ""));
    }
    return total;
  };

  const calculateDiscount = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseFloat(data[i].discount_amount) * 1;
    }
    return total;
  };

  const calculatePerProdCost = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        parseFloat(
          data[i].cost_per_prod !== null
            ? parseInt(data[i].is_per_piece) === 0
              ? data[i].cost_per_prod
              : data[i].cost_per_prod * data[i].quantity
            : 0
        ) * 1;
    }
    return total;
  };

  useEffect(() => {
    getMerchantOrderDetails();
    getEmployeeList();
  }, [getMerchantOrderDetails, getEmployeeList]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
    },
  });

  const handleAddWaste = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "transaction_id",
      tableData !== null ? tableData.transaction_id : ""
    );
    formdata.append(
      "product_id",
      tableData !== null ? tableData.product_id : ""
    );
    formdata.append(
      "description",
      tableData !== null ? tableData.description : ""
    );
    formdata.append("price", tableData !== null ? tableData.price : "");
    formdata.append(
      "created_at",
      tableData !== null
        ? moment.utc(tableData.created_at).format("YYYY-MM-DD HH:mm:ss")
        : ""
    );
    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoading(true);
    axios
      .post("user/merchant/add-waste", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Add waste successfully.");
          setTimeout(() => {
            rerunWaste();
            setLoading(false);
            setOpenAddWaste(false);
          }, 1000);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleVoidSpecProd = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", tableData !== null ? tableData.id : "");
    formdata.append(
      "transaction_id",
      tableData !== null ? tableData.transaction_id : ""
    );
    formdata.append(
      "product_id",
      tableData !== null ? tableData.product_id : ""
    );
    formdata.append(
      "description",
      tableData !== null ? tableData.description : ""
    );
    formdata.append("price", tableData !== null ? tableData.price : "");
    formdata.append(
      "order_quantity",
      tableData !== null ? tableData.quantity : ""
    );
    formdata.append(
      "created_at",
      tableData !== null
        ? moment.utc(tableData.created_at).format("YYYY-MM-DD HH:mm:ss")
        : ""
    );

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoading(true);
    axios
      .post("user/merchant/spec/void-product", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Void product successfully.");
          if (orderDetailsList.ready && orderDetailsList.data.length > 1) {
            setTimeout(() => {
              getMerchantOrderDetails();
              setOpenVoidTransaction(false);
            }, 1000);
          } else {
            setTimeout(() => {
              rerunVoid();
              close();
            }, 1000);
          }
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  //   console.log("selectedData: ", selectedData);

  const handleClearTransaction = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("merchant_uid", userData.data.merchant_uid);
    formdata.append(
      "total_cost",
      parseFloat(totalCost + totalPerProd - totalDiscount)
    );
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    formdata.append(
      "orig_date_trnx",
      selectedData !== null ? selectedData.created_at : ""
    );
    formdata.append(
      "allow_inventory",
      subscriptionDetails.data.subsmerchantfeat.enable_inventory_report
    );
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    var error = [];
    var cashpayment = parseFloat(
      inputtedPayment !== null ? inputtedPayment : 0
    );
    var ecashpayment = parseFloat(
      inputtedEcashPayment !== null ? inputtedEcashPayment : 0
    );
    if (
      parseFloat(cashpayment + ecashpayment) <
      parseFloat(totalCost + totalPerProd - totalDiscount)
    ) {
      error = "error";
    }
    if (error.length > 0) {
      rerunNotif("error", "Payment input invalid.");
    } else {
      setLoading(true);
      axios
        .post("user/merchant/ar/confirm-payment", formdata)
        .then((response) => {
          const data = response.data;
          if (data === "success") {
            rerunNotif("success", "Confirm payment successfully.");
            setTimeout(() => {
              getMerchantOrderSaveList();
              close();
              setLoading(false);
            }, 1000);
          }
        })
        .catch((error) => {
          console.log("ERROR: ", error);
          setLoading(false);
        });
    }
  };

  return (
    <Drawer
      title="Receipt"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <div>
          <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
          >
            Print
          </Button>
        </div>
      }
    >
      {selectedData !== null && (
        <>
          <div
            style={{ overflowX: "auto", padding: paddingPrint }}
            ref={componentRef}
          >
            <div
              style={{
                display: "flex",
                // flexDirection: "column",
                paddingRight: 15,
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <div style={{ flexGrow: 1 }}>
                <Typography
                  style={{
                    //  fontWeight: "bold",
                    fontSize: 14,
                  }}
                >
                  Employee Name:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {orderDetailsList.ready &&
                      orderDetailsList.data[0].chargetoemployeeinfo.lastname}
                    ,
                    {orderDetailsList.ready &&
                      orderDetailsList.data[0].chargetoemployeeinfo.firstname}
                  </span>
                </Typography>
                <Typography
                  style={{
                    // fontWeight: "bold",
                    fontSize: 14,
                    display:
                      orderDetailsList.ready &&
                      orderDetailsList.data[0].table_no !== "Table #"
                        ? "block"
                        : "none",
                  }}
                >
                  {/* {allowDineSetup ? "Location" : "Table Number"}:{" "} */}
                  Location:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {orderDetailsList.ready &&
                      orderDetailsList.data[0].table_no}
                  </span>
                </Typography>
                <Typography
                  style={{
                    fontSize: 14,
                    display:
                      orderDetailsList.ready &&
                      orderDetailsList.data[0].contact_no !== null
                        ? "block"
                        : "none",
                  }}
                >
                  Customer #:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {orderDetailsList.ready &&
                      orderDetailsList.data[0].contact_no}
                  </span>
                </Typography>
                <Typography
                  style={{
                    fontSize: 14,
                    display:
                      orderDetailsList.ready &&
                      orderDetailsList.data[0].customer_address !== null
                        ? "block"
                        : "none",
                  }}
                >
                  Customer Address:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {orderDetailsList.ready &&
                      orderDetailsList.data[0].customer_address}
                  </span>
                </Typography>
                <Typography
                  style={{
                    // fontWeight: "bold",
                    fontSize: 14,
                    textTransform: "capitalize",
                  }}
                >
                  Status:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {orderDetailsList.ready &&
                      orderDetailsList.data[0].service_category}
                  </span>
                </Typography>
                <Typography
                  style={{
                    // fontWeight: "bold",
                    fontSize: 14,
                    textTransform: "capitalize",
                    // marginBottom: 10,
                  }}
                >
                  Transaction #:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {orderDetailsList.ready &&
                      orderDetailsList.data[0].transaction_id}
                  </span>
                </Typography>

                {orderDetailsList.ready &&
                  orderDetailsList.data[0].service_type !== null && (
                    <Typography
                      style={{
                        // fontWeight: "bold",
                        fontSize: 14,
                        textTransform: "capitalize",
                        // marginBottom: 10,
                      }}
                    >
                      Service Type:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {orderDetailsList.data[0].service_type}
                      </span>
                    </Typography>
                  )}

                {orderDetailsList.ready &&
                  orderDetailsList.data[0].e_ref_no !== null && (
                    <Typography
                      style={{
                        fontSize: 14,
                      }}
                    >
                      Reference #:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {orderDetailsList.data[0].e_ref_no}
                      </span>
                    </Typography>
                  )}
              </div>
              <div>
                {orderDetailsList.ready &&
                  orderDetailsList.data[0].customerordercashiered !== null && (
                    <Typography
                      style={{
                        fontSize: 14,
                      }}
                    >
                      Cashiered By:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {orderDetailsList.ready &&
                          orderDetailsList.data[0].customerordercashiered
                            .firstname}
                      </span>
                    </Typography>
                  )}
                {orderDetailsList.ready &&
                  orderDetailsList.data[0].customerorderdispatched !== null && (
                    <Typography
                      style={{
                        fontSize: 14,
                      }}
                    >
                      Dispatched By:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {orderDetailsList.ready &&
                          orderDetailsList.data[0].customerorderdispatched
                            .firstname}
                      </span>
                    </Typography>
                  )}

                {orderDetailsList.ready &&
                  orderDetailsList.data[0].customerorderserved !== null && (
                    <Typography
                      style={{
                        fontSize: 14,
                      }}
                    >
                      Served By:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {orderDetailsList.ready &&
                          orderDetailsList.data[0].customerorderserved
                            .firstname}
                      </span>
                    </Typography>
                  )}
              </div>
            </div>

            {orderDetailsList.ready &&
            orderDetailsList.data.length > 0 &&
            orderDetailsList.data[0].service_type === "consumable" ? (
              <>
                {newOrderDetailsList.ready &&
                  newOrderDetailsList.data.map((data, index) => (
                    <div key={index}>
                      <Divider>
                        {data.order_category === "additional-service"
                          ? "Service"
                          : "Products"}
                      </Divider>
                      <Table
                        {...tableProps}
                        pagination={false}
                        columns={
                          data.order_category === "additional-service"
                            ? tableColumns2
                            : tableColumns
                        }
                        dataSource={data.data.length > 0 ? data.data : []}
                        scroll={scroll}
                        rowKey={(record) => record.id}
                        expandable={{
                          expandedRowRender: (record) => (
                            <p style={{ margin: 0 }}>
                              Discount by
                              {/* {console.log("record", record)} */}
                              {record.discount_category === "percentage"
                                ? `(${record.price} * ${record.discount_percentage}%) * ${record.discount_quantity} = ${record.discount_amount}`
                                : `${record.discount_amount}`}
                            </p>
                          ),
                          rowExpandable: (record) =>
                            record.discount_category !== null,
                        }}
                        footer={() => (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{ flexGrow: 1, fontWeight: "bold" }}
                            ></div>
                            <Typography style={{ textAlign: "right" }}>
                              Total:{" "}
                              {parseFloat(
                                data.total + data.perproduct
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                            {data.discount !== 0 && (
                              <>
                                <Typography style={{ textAlign: "right" }}>
                                  Discount:{" "}
                                  {data.discount.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Typography>
                                <Typography style={{ textAlign: "right" }}>
                                  Grand Total:{" "}
                                  {parseFloat(
                                    data.total + data.perproduct - data.discount
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Typography>
                              </>
                            )}
                          </div>
                        )}
                      />
                    </div>
                  ))}

                <div
                  style={{ display: "flex", paddingRight: 15, marginTop: 10 }}
                >
                  <div style={{ flexGrow: 1 }} />
                  <div>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        fontSize: 14,
                        textAlign: "right",
                      }}
                    >
                      Total Cost: &#8369;
                      {parseFloat(
                        newOrderDetailsList.data.length > 1
                          ? parseFloat(
                              newOrderDetailsList.data[0].total +
                                newOrderDetailsList.data[0].perproduct -
                                newOrderDetailsList.data[0].discount
                            ) >
                            parseFloat(
                              newOrderDetailsList.data[1].total +
                                newOrderDetailsList.data[1].perproduct -
                                newOrderDetailsList.data[1].discount
                            )
                            ? newOrderDetailsList.data[0].total +
                              newOrderDetailsList.data[0].perproduct -
                              newOrderDetailsList.data[0].discount
                            : newOrderDetailsList.data[1].total +
                              newOrderDetailsList.data[1].perproduct -
                              newOrderDetailsList.data[1].discount
                          : newOrderDetailsList.data[0].total +
                              newOrderDetailsList.data[0].perproduct -
                              newOrderDetailsList.data[0].discount
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                  </div>
                </div>
              </>
            ) : (
              <>
                <Table
                  {...tableProps}
                  pagination={false}
                  columns={tableColumns}
                  dataSource={
                    orderDetailsList.data.length > 0
                      ? orderDetailsList.data
                      : []
                  }
                  scroll={scroll}
                  rowKey={(record) => record.id}
                  expandable={{
                    expandedRowRender: (record) => (
                      <p style={{ margin: 0 }}>
                        Discount by{" "}
                        {record.discount_category === "percentage"
                          ? `(${record.price} * ${record.discount_percentage}%) * ${record.discount_quantity} = ${record.discount_amount}`
                          : `${record.discount_amount}`}
                      </p>
                    ),
                    rowExpandable: (record) =>
                      record.discount_category !== null,
                  }}
                />

                <div
                  style={{ display: "flex", paddingRight: 15, marginTop: 10 }}
                >
                  <div style={{ flexGrow: 1 }} />
                  <div>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        fontSize: 14,
                        textAlign: "right",
                      }}
                    >
                      Total Cost: &#8369;
                      {totalCost.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                    {userData.data.perproductcost !== null && (
                      <Typography
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          textAlign: "right",
                        }}
                      >
                        Total {userData.data.perproductcost.description}:
                        &#8369;
                        {totalPerProd.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Typography>
                    )}
                    {totalDiscount > 0 && (
                      <Typography
                        style={{
                          fontWeight: "bold",
                          fontSize: 14,
                          textAlign: "right",
                        }}
                      >
                        Total Discount: &#8369;
                        {totalDiscount.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Typography>
                    )}
                    <Typography
                      style={{
                        fontWeight: "bold",
                        fontSize: 14,
                        textAlign: "right",
                      }}
                    >
                      Grand Total: &#8369;
                      {parseFloat(
                        totalCost + totalPerProd - totalDiscount
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      )}

      <Button
        type="primary"
        loading={loading}
        style={{ width: "100%", borderRadius: "20px" }}
        onClick={() => {
          setOpenConfirmDiag(true);
        }}
      >
        {!loading ? "Proceed To Payment" : "Loading"}
      </Button>

      <Modal
        title=""
        open={openAddWaste}
        onCancel={() => setOpenAddWaste(false)}
        footer={null}
        width={350}
        centered
      >
        <div style={{ marginBottom: 10, marginTop: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Add Waste
          </Typography>
        </div>

        <Form
          layout="vertical"
          name="add-waste"
          initialValues={{
            product: tableData !== null ? tableData.product : "",
          }}
          onFinish={handleAddWaste}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="product"
              label="Product Name"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input placeholder="Set product name" size="large" disabled />
            </Form.Item>

            <Form.Item
              name="employee_id"
              label="Employee"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select employee"
                size="large"
                showSearch
                // filterOption={(input, option) =>
                //   option.props.children
                //     .toLowerCase()
                //     .indexOf(input.toLowerCase()) >= 0
                // }
              >
                {employeeList.data.length > 0 ? (
                  employeeList.data.map((data, index) => (
                    <Select.Option value={data.id} key={index}>
                      {data.firstname} {data.lastname}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option value="">No employee found!</Select.Option>
                )}
              </Select>
            </Form.Item>

            <Form.Item
              name="quantity"
              // label="Waste Quantity"
              label={
                tableData !== null && parseInt(tableData.is_per_piece) === 1
                  ? "Waste Quantity"
                  : "Waster Gram(s)"
              }
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={1}
                max={999999999999}
                size="large"
                style={{ width: "100%" }}
                step="1"
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Add"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title=""
        open={openVoidTransaction}
        onCancel={() => setOpenVoidTransaction(false)}
        footer={null}
        width={350}
        centered
      >
        <div style={{ marginBottom: 10, marginTop: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Void Specific Product
          </Typography>
        </div>

        <Form
          layout="vertical"
          name="void-spec-tranx"
          initialValues={{
            product: tableData !== null ? tableData.product : "",
          }}
          onFinish={handleVoidSpecProd}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="product"
              label="Product Name"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input placeholder="Set product name" size="large" disabled />
            </Form.Item>

            <Form.Item
              name="quantity"
              // label="Void Quantity"
              label={
                tableData !== null && parseInt(tableData.is_per_piece) === 1
                  ? "Void Quantity"
                  : "Void Gram(s)"
              }
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={1}
                max={tableData !== null ? tableData.quantity : 0}
                size="large"
                style={{ width: "100%" }}
                step="1"
              />
            </Form.Item>

            <Form.Item
              name="reason"
              label="Reason"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <TextArea
                placeholder="Set reason"
                autoSize
                size="large"
                // style={{ textTransform: "uppercase" }}
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Add"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title=""
        open={openConfirmDiag}
        onCancel={() => setOpenConfirmDiag(false)}
        footer={null}
        centered
      >
        <Form
          layout="vertical"
          name="merchant-payment-confirm4"
          initialValues={{
            total_cost: totalCost + totalPerProd - totalDiscount,
          }}
          onFinish={handleClearTransaction}
          autoComplete="off"
          form={form}
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <div
              style={{
                marginTop: 20,
                marginBottom: 5,
              }}
            >
              <Typography>Total Cost</Typography>
            </div>

            <div
              style={{
                border: "1px solid #e5e5e5",

                marginBottom: 20,
                padding: 10,
                borderRadius: 10,
              }}
            >
              {parseFloat(
                totalCost + totalPerProd - totalDiscount
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>

            <Form.Item
              name="method"
              label="Method"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select method"
                onChange={(e) => {
                  setSelectedMethod(e);
                  setInputtedPayment(null);
                  setInputtedEcashPayment(null);
                  form.setFieldsValue({
                    noncash: null,
                    customer_payment: null,
                    customer_epayment: null,
                    e_ref_no: null,
                  });
                }}
                size="large"
                showSearch
              >
                <Select.Option value={"enter-payment"}>
                  Confirm w/ Cash Payment
                </Select.Option>
                <Select.Option value={"ecash-payment"}>
                  Confirm w/ ECash Payment
                </Select.Option>
                <Select.Option value={"split-payment"}>
                  Split Payment
                </Select.Option>
              </Select>
            </Form.Item>

            {selectedMethod === "enter-payment" && (
              <Form.Item
                name="customer_payment"
                label="Cash Payment"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <InputNumber
                  min={1}
                  max={999999999999}
                  initialvalues={0}
                  size="large"
                  style={{ width: "100%" }}
                  step="0.01"
                  onChange={(value) => {
                    setInputtedPayment(value);
                  }}
                />
              </Form.Item>
            )}

            {selectedMethod === "ecash-payment" && (
              <>
                <Form.Item
                  name="noncash"
                  label="Non-cash"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select non-cash"
                    onChange={(e) => {
                      // setSelectedMethod(e);
                      setInputtedPayment(null);
                      setInputtedEcashPayment(null);
                      form.setFieldsValue({
                        customer_payment: null,
                        customer_epayment: null,
                        e_ref_no: null,
                      });
                    }}
                    size="large"
                    showSearch
                  >
                    <Select.Option value={"gcash"}>GCash</Select.Option>
                    <Select.Option value={"gcredit"}>GCredit</Select.Option>
                    <Select.Option value={"paymaya"}>Paymaya</Select.Option>
                    <Select.Option value={"creditcard"}>
                      Credit Card
                    </Select.Option>
                    <Select.Option value={"debitcard"}>
                      Debit Card
                    </Select.Option>
                    <Select.Option value={"banktransfer"}>
                      Bank Transfer
                    </Select.Option>
                    <Select.Option value={"cheque"}>Cheque</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name="customer_epayment"
                  label="ECash Payment"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="0.01"
                    onChange={(value) => setInputtedEcashPayment(value)}
                  />
                </Form.Item>
                <Form.Item
                  name="e_ref_no"
                  label="Reference #"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Input placeholder="Set ref no" size="large" />
                </Form.Item>
              </>
            )}

            {selectedMethod === "split-payment" && (
              <>
                <Form.Item
                  name="customer_payment"
                  label="Cash Payment"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="0.01"
                    onChange={(value) => setInputtedPayment(value)}
                  />
                </Form.Item>

                <Form.Item
                  name="noncash"
                  label="Non-cash"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select non-cash"
                    onChange={(e) => {
                      setInputtedPayment(null);
                      setInputtedEcashPayment(null);
                      form.setFieldsValue({
                        customer_payment: null,
                        customer_epayment: null,
                        e_ref_no: null,
                      });
                    }}
                    size="large"
                    showSearch
                  >
                    <Select.Option value={"gcash"}>GCash</Select.Option>
                    <Select.Option value={"gcredit"}>GCredit</Select.Option>
                    <Select.Option value={"paymaya"}>Paymaya</Select.Option>
                    <Select.Option value={"creditcard"}>
                      Credit Card
                    </Select.Option>
                    <Select.Option value={"debitcard"}>
                      Debit Card
                    </Select.Option>
                    <Select.Option value={"banktransfer"}>
                      Bank Transfer
                    </Select.Option>
                    <Select.Option value={"cheque"}>Cheque</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name="customer_epayment"
                  label="ECash Payment"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="0.01"
                    onChange={(value) => setInputtedEcashPayment(value)}
                  />
                </Form.Item>
                <Form.Item
                  name="e_ref_no"
                  label="Reference #"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Input placeholder="Set ref no" size="large" />
                </Form.Item>
              </>
            )}

            {selectedMethod === "enter-payment" ? (
              <>
                {inputtedPayment !== null && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      border: "1px solid green",
                    }}
                  >
                    <Typography style={{ fontSize: 22, fontWeight: "bold" }}>
                      &#8369;
                      {parseFloat(
                        parseFloat(inputtedPayment) -
                          parseFloat(totalCost + totalPerProd - totalDiscount)
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                    <Typography style={{ color: "green", fontWeight: "bold" }}>
                      Change
                    </Typography>
                  </div>
                )}
              </>
            ) : null}
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Confirm"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </Drawer>
  );
};

export default MerchantARReportOrderDetails;
